import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import React from "react";
import { Controller } from 'react-hook-form';
import { MyMButton } from '../ui-elements/MyMButton';

export const ValidatableInputFile = (props) => {
  const { control, btnLayout, displayName, changeFunction, name, rules, formState, displayMessage=true } = props;
  return (
    <FormControl error={formState.errors[name] ? true : false} sx={{width: "100%"} }>
      <Controller
        control={control}
        name={name}
        defaultValue=''
          render={({ field: { onChange } }) => (
            <MyMButton component="label" sx={btnLayout}>
              {displayName }
              <input
                type='file'
                hidden
                onChange={(e) => { onChange(e.target.files); changeFunction(e); }}
              />
            </MyMButton>
          )}
        rules={rules}
      />
      <FormHelperText >{displayMessage && formState.errors[name]?.message}</FormHelperText>
    </FormControl>
  );
}